import styled, { keyframes } from 'styled-components';
import { TitleSmall500 } from '@nebula/global-styles';
import Button from '@nebula/button';

export const PaymentDivider = styled(TitleSmall500)`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-gap: 0.625rem;
  margin: 1rem 2rem;
  ::before,
  ::after {
    content: '';
    border-top: 0.0625rem double ${({ theme }) => theme.color.ui.grey[30]};
    align-self: center;
  }
`;

export const SubTitle = styled(TitleSmall500)`
  margin: 0 0 0.25rem;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    margin: 0 0 0.5rem;
  }
`;

export const PaymentMethod = styled.div`
  margin: 0 0 1rem;
  padding: 0.5625rem 1rem;
  background-color: ${({ theme }) => theme.color.brand.white};
  border: 0.0625rem solid ${({ theme }) => theme.color.ui.grey[20]};
  border-radius: ${({ theme }) => theme.borderRadius.small.rem};
  box-shadow: ${({ theme }) => theme.elevation.raised10};
  @media ${({ theme }) => theme.media.smallDesktopMin} {
    margin: 0 0 1.5rem;
  }
`;

export const ApplePayOption = styled.div`
  ${({ disabled }) => disabled && 'pointer-events: none;'};
`;

export const GooglePayOption = styled.div`
  ${({ disabled }) => disabled && 'pointer-events: none;'};
`;

export const PaymentMethodTitle = styled(TitleSmall500)`
  display: flex;
  align-items: center;
  > svg {
    margin-right: 1rem;
  }
`;

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.span`
  display: none;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  background-color: transparent;
  border: 0.125rem solid rgba(255, 255, 255, 0.25);
  border-top-color: ${({ theme }) => theme.color.ui.white};
  border-radius: ${({ theme }) => theme.borderRadius.circle.rem};
  animation: ${spin} 0.75s infinite linear;
  @media ${({ theme }) => theme.media.shouldAnimate} {
    display: flex;
  }
`;

export const ConfirmButton = styled(Button)`
  width: 100%;
  min-width: 12.5rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: fit-content;
  }
`;

export const PaymentDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.color.ui.grey[90]};
  margin-top: -10px;
  margin-bottom: 24px;
  @media ${({ theme }) => theme.media.smallDesktopMin} {
    margin-top: -16px;
  }
`;

export const PaymentSection = styled.div`
  width: 55%;
  margin-left: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  @media ${({ theme }) => theme.media.tabletLandscapeMax} {
    width: 60%;
  }
  @media ${({ theme }) => theme.media.tabletPortraitMax} {
    width: 100%;
  }
  p {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

export const GooglePayContainer = styled.div`
  display: flex;
  align-items: center;
  height: 3rem;
  div,
  button {
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-family: 'Product Sans', sans-serif;
  }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const GooglePaySkeleton = styled.div`
  height: 3rem;
  width: 100%;
  border-radius: 0.25rem;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  @media ${({ theme }) => theme.media.shouldAnimate} {
    animation: ${shimmer} 1.5s ease-in-out infinite;
  }
`;
